import { render, staticRenderFns } from "./_CustomMarket.vue?vue&type=template&id=3629fc5b&scoped=true&"
import script from "./_CustomMarket.vue?vue&type=script&lang=js&"
export * from "./_CustomMarket.vue?vue&type=script&lang=js&"
import style0 from "./_CustomMarket.vue?vue&type=style&index=0&id=3629fc5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629fc5b",
  null
  
)

export default component.exports